itsoftApp.createModule("social", ["pageLoad"], function () {
    const module = this;

    const libraries = {
        sharer: {
            name: "likely",
            queue: [],
            started: false,
            loaded: false,
            script: "/assets/scripts/sharer/sharer.min.js"
        }
    }

    const startSocial = function () {
        const socialButtons = document.querySelectorAll(".js-social-btn");

        Array.prototype.forEach.call(socialButtons, function (button) {
            button.setAttribute("data-url", location.href);
            Sharer.init();
        });
    }

    const initSocial = function (el) {
        new itsoftApp.modules.startLoad.callback(startSocial, libraries.sharer);
    }

    module.initSocial = initSocial;
});